import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import Button from 'components/UIKit/Button/Button';
import { toggle } from 'components/UIKit/decorators';
import { Spinner } from 'components/UIKit/Spinner';
import { HelpIcon, WaitIcon } from 'components/icons';
import { Tooltip } from 'components/UIKit/Tooltip';

type Props = {
  BottomComponent: ?Object,
  MainComponent: Object,
  active: boolean,
  children: any,
  toggleActive(): void,
  tooltip: Object,
  isFetching: boolean,
  more: boolean,
  style: Object,
  title: Node,
}

const styles = {
  base: {
    flex: 1,
    background: 'none',
    border: 'none',
    display: 'block',
  },
};

const FlipCard = ({
  active,
  BottomComponent,
  isFetching,
  MainComponent,
  more,
  style,
  title,
  toggleActive,
  tooltip,
  ...rest
}: Props) => (
  // need display: 'block' otherwise graph widgets get super tall.
  // height x n graph in the row  ... i dunno.
  <Row style={{ ...styles.base, ...style }} {...rest}>
    <Row style={{ justifyContent: 'center' }}>
      { tooltip
        && (
          <Row style={{ marginRight: '0.2rem' }}>
            <Tooltip Component={<Row style={{ ...tooltip.size }}>{tooltip.text}</Row>}>
              <HelpIcon style={{ fontSize: '1.1rem', color: '#2a72a5', paddingBottom: 2 }} />
            </Tooltip>
          </Row>
        )
      }
      <Row style={{ fontSize: '0.9rem' }}>{ title }</Row>
    </Row>
    <Column>
      <Column>
        {isFetching ? (
          <div style={{
            position: `absolute`,
            top: 0,
            left: 0,
            height: `100%`,
            width: `100%`,
            zIndex: 20,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`
          }}>
            <Row>
              <WaitIcon style={{ fontSize: '4rem', color: '#2a72a5' }} />
              <Spinner
                style={{
                  position: 'absolute',
                  top: '0rem',
                  left: '0rem',
                  opacity: 1,
                  width: '4rem',
                  height: '4rem',
                }}
                />
            </Row>
          </div>
        ) : null}
        {MainComponent}
      </Column>
    </Column>

    { BottomComponent
    && (
      <Row>
        <Column style={{ flex: 1, justifyContent: 'flex-start' }}>
          {/* optional third element */}
          {BottomComponent}
        </Column>

        <Column style={{ justifyContent: 'flex-end' }}>
          <Row style={{ justifyContent: 'flex-end' }}>
            {!!(!isFetching && more)
            && (
              <Button onClick={toggleActive} style={{ marginTop: '.5rem' }}>
                {active ? 'less' : 'more'}
              </Button>
            )
          }
          </Row>
        </Column>
      </Row>
    )
    }
  </Row>
);

export default toggle(FlipCard);
